import script from "./PayslipItemSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayslipItemSummary.vue?vue&type=script&setup=true&lang=ts"

import "./PayslipItemSummary.vue?vue&type=style&index=0&id=49a07c24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a07c24"]])

export default __exports__